import React, {Fragment} from 'react';
import {FormField, Input} from "semantic-ui-react";
import NumberInput from "../../../controls/numberInput";
import {calcVolume, changeValues} from "./math";

const CalcByPlaces = ({changeParam, positions, errors, isCreate, disabled}) => {

    const changeInput = (name, value, index) => {

        let v = [...positions];
        v[index] = {
            ...v[index],
            [name]: value
        }

        changeParam('positions', v)
        changeValues({positions: v}, null, null, changeParam, true);
    }

    const addPosition = () => {
        const newPositions = [...positions, {cargoPackages: 1}];
        changeParam('positions', newPositions);
        changeValues({positions: newPositions}, null, null, changeParam, true);
    }

    const deletePosition = (index) => {
        let v = [...positions];
        v.splice(index, 1);
        changeParam('positions', v);
        changeValues({positions: v}, null, null, changeParam, true);
    }

    return <Fragment>
        {
            (positions || [{}]).map((place, index) => (
                <div className='calc-by-places d-flex' key={"position_" + index}>
                    <div className='calc-by-places__number'>{index + 1}</div>
                    <div className='d-flex inputs'>
                        <FormField className='calc-by-places__input' error={errors[`positions.${index}.length`]}>
                            {index === 0 && <label>Длина, см*</label>}
                            <NumberInput
                                disabled={disabled}
                                value={place.length}
                                decimals="5"
                                min="0"
                                onChange={value => changeInput("length", value, index)}
                            />
                        </FormField>
                        <FormField className='calc-by-places__input' error={errors[`positions.${index}.width`]}>
                            {index === 0 && <label>Ширина, см*</label>}
                            <NumberInput
                                disabled={disabled}
                                value={place.width}
                                decimals="5"
                                min="0"
                                onChange={value => changeInput("width", value, index)}
                            />
                        </FormField>
                        <FormField error={errors[`positions.${index}.height`]}>
                            {index === 0 && <label>Высота, см*</label>}
                            <NumberInput
                                disabled={disabled}
                                value={place.height}
                                decimals="5"
                                min="0"
                                onChange={value => changeInput("height", value, index)}
                            />
                        </FormField>
                    </div>
                    <div className='d-flex inputs'>
                        <FormField error={errors[`positions.${index}.weight`]}>
                            {index === 0 && <label>Вес{isCreate ? ' места' : ''}, кг*</label>}
                            <NumberInput
                                disabled={disabled}
                                value={place.weight}
                                decimals="3"
                                min="0"
                                onChange={value => changeInput("weight", value, index)}
                            />
                        </FormField>
                        <FormField>
                            {index === 0 && <label>Объем{isCreate ? ' места' : ''}, м³</label>}
                            <Input
                                className='input_m-r input_mini'
                                value={Number.parseFloat(calcVolume(place)).toFixed(3)}
                                disabled
                            />
                        </FormField>
                        <FormField error={errors[`positions.${index}.cargoPackages`]}>
                            {index === 0 && <label>Кол-во мест*</label>}
                            <NumberInput
                                disabled={disabled}
                                value={(disabled && !isCreate) ? place.packagesCount : place.cargoPackages}
                                decimals="5"
                                min="0"
                                onChange={value => changeInput("cargoPackages", value, index)}
                            />
                        </FormField>
                    </div>

                    {!disabled && <div className='calc-by-places__btns'>
                        {positions && positions.length > 1 &&
                            <div className={`calc-by-places__btn ${disabled ? 'disabled' : ''}`}
                                 onClick={() => deletePosition(index)}>
                                <svg width="28" height="28" viewBox="0 0 28 28" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="14" cy="14" r="13" fill="white" stroke="#135CA9" strokeWidth="2"/>
                                    <path d="M20.25 13V15.0417L8 15.0417L8 13L20.25 13Z" fill="#135CA9"/>
                                </svg>
                            </div>}

                        <div className={`calc-by-places__btn ${disabled ? 'disabled' : ''}`}
                             onClick={() => addPosition()}>
                            <svg width="28" height="28" viewBox="0 0 28 28" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <circle cx="14" cy="14" r="13" fill="white" stroke="#135CA9" strokeWidth="2"/>
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M15.0208 8.2644H12.9792V13.621H7.87501L7.87501 15.7637H12.9792V21.1203H15.0208V15.7637H20.125V13.621H15.0208V8.2644Z"
                                      fill="#135CA9"/>
                            </svg>
                        </div>

                    </div>}
                </div>
            ))
        }
    </Fragment>
}

export default CalcByPlaces;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/calcByPlaces.jsx